import {
  SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT,
  SET_INFORMATION_DISPLAYED_LIST, SET_INFORMATION_TOASTER_STATE, SET_INFORMATION_TOASTER_TEXT
} from '../mutation-types'
import {FROM_INTERACTIONS_LIST} from '../getter-types'

export const informationTexts = {
  INTERVENTION_CREATED: 'intervention_created',
  FORBIDDEN_RESOURCE: 'forbidden_resource_snackbar',
  INTERVENTION_UPDATED: 'intervention_updated',
  ALERT_EMAIL_SAVED: 'admin.alerts.email.saved',
  ALERTS_COURSE_UPDATED: 'admin.alerts.course_selection.updated',
  EXEMPTION_CREATED: 'exemption.created',
  EXEMPTION_UPDATED: 'exemption.updated',
  EXEMPTION_DELETED: 'exemption.deleted',
  FEED_STARTED: 'feeds.in_progress',
  FEED_ALREADY_RUNNING: 'feeds.blocked',
  FEED_UNABLE: 'feeds.unable',
  ANNOUNCEMENT_UPDATED: 'announcements.admin.information.updated',
  ANNOUNCEMENT_CREATED: 'announcements.admin.information.created',
  ANNOUNCEMENT_STATUS_UPDATED: 'announcements.admin.information.status',
  SAVE_FILTER_CANCEL: 'save_filter_cancelled',
  SAVE_FILTER_CREATED: 'save_filter_created',
  CHART_CREATED: 'dashboard.chart_created',
  CREATE_CHART_FILTER_CANCELLED: 'dashboard.chart.filter_cancelled',
  CHART_FILTER_UPDATED: 'dashboard.chart.filter_updated',
  CHART_UPDATED_WITH_NEW_FILTER: 'dashboard.chart.new_filter_updated',
  CHART_REORDER_APPLIED: 'dashboard.chart.reorder_applied',
  CHART_REORDER_CANCELLED: 'dashboard.chart.reorder_cancelled',
  ALERT_ACTIVATED: 'admin.alerts.new.activated',
  ALERT_DEACTIVATED: 'admin.alerts.new.deactivated',
  COPY_TO_CLIPBOARD: 'admin.alerts.new.placeholders.clipboard_copy',
  SUBMITTED_DATA_SET: 'admin.alerts.new.data_sets.submitted',
  ALERT_CREATED: 'admin.alerts.new.created',
  ALERT_COPIED: 'admin.alerts.new.copied',
  ALERT_UPDATED: 'admin.alerts.new.updated',
  SUBMITTED_EMAIL_TEMPLATE: 'admin.alerts.new.email_templates.submitted',
  FEED_ACTIVATED: 'feeds.activated',
  FEED_DEACTIVATED: 'feeds.deactivated',
  FEED_RUN_CANCEL: 'feeds.feed_run_cancelled'
}

export const listNames = {
  MY_STUDENTS: 'MY_STUDENTS',
  INTERACTIONS: 'INTERACTIONS'
}

const state = {
  snackbar: false,
  snackbarText: informationTexts.INTERVENTION_CREATED,
  toaster: false,
  toasterText: '',
  listName: ''
}

const mutations = {
  [SET_INFORMATION_SNACKBAR_STATE] (state, value) {
    state.snackbar = value
  },
  [SET_INFORMATION_SNACKBAR_TEXT] (state, value) {
    state.snackbarText = value
  },
  [SET_INFORMATION_TOASTER_STATE] (state, value) {
    state.toaster = value
  },
  [SET_INFORMATION_TOASTER_TEXT] (state, value) {
    state.toasterText = value
  },
  [SET_INFORMATION_DISPLAYED_LIST] (state, listName) {
    state.listName = listName
  }
}

const getters = {
  [FROM_INTERACTIONS_LIST]: (state) => {
    return state.listName === listNames.INTERACTIONS
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/information.js